import ReactGA from 'react-ga4';

const MEASUREMENT_ID = 'G-GND7ETMJJE';

// Initialize GA4
export const initGA = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const isPrerender = typeof window !== 'undefined' && window.__PRERENDER_INJECTED !== undefined;

  if (!isDevelopment && !isPrerender) {
    ReactGA.initialize(MEASUREMENT_ID, {
      gaOptions: {
        anonymizeIp: true,
      },
    });
  }
};

// Track page views (automatic on route changes)
export const trackPageView = (path) => {
  if (process.env.NODE_ENV !== 'development') {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

// Track custom events
export const trackEvent = (category, action, label = null) => {
  if (process.env.NODE_ENV !== 'development') {
    ReactGA.event({
      category,
      action,
      label,
    });
  }
};

// Track CV downloads
export const trackCVDownload = () => {
  trackEvent('Engagement', 'CV Download', 'Hero Section');
};

// Track project clicks
export const trackProjectClick = (projectName, linkType) => {
  trackEvent('Project', 'Click', `${projectName} - ${linkType}`);
};

// Track social media clicks
export const trackSocialClick = (platform) => {
  trackEvent('Social', 'Click', platform);
};

// Track contact interactions
export const trackContactClick = (method) => {
  trackEvent('Contact', 'Click', method);
};
